import React from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactTooltip from "react-tooltip";
import { actionCreators } from "../redux/sagas/utilization";
import ToggleableButton from "../../../../components/toggleableButton/toggleableButton";

export const FutureBookings = () => {
  const dispatch = useDispatch();

  const future_bookings = useSelector((state) => state.utilization.future_bookings);

  const tooltipId = "booking-date-tooltip";

  return (
    <>
      <p data-for={tooltipId} data-tip="Future Bookings are available for the Next 30 Days">
        Future Bookings
      </p>

      <ToggleableButton
        isActive={future_bookings}
        isRadio
        title="future_booking"
        onClick={(data) => dispatch(actionCreators.updateFutureBookings(data))}
      />

      <ReactTooltip id={tooltipId} />
    </>
  );
};
